import { RoleEnum } from '@/app/enums/RoleEnum';
import { IUserDTO } from '@/modules/auth/dtos/user.dto';
import { IUser } from '@/modules/auth/entities/user.entity';

export class UserMapper {
  static toPresentation(dto: IUserDTO): IUser {
    return {
      id: dto.id,
      name: dto.nome,
      email: dto.email,
      lastName: dto.sobrenome,
      avatarUrl: dto.avatarUrl,
      fullName: `${dto.nome} ${dto.sobrenome}`,
      role: dto.superAdmin ? RoleEnum.ADMIN_MASTER : RoleEnum.READER,
    };
  }

  static toDTO(entity: IUser): IUserDTO {
    return {
      id: entity.id,
      nome: entity.name,
      email: entity.email,
      sobrenome: entity.lastName,
      avatarUrl: entity.avatarUrl,
      superAdmin: entity.role === RoleEnum.ADMIN_MASTER,
    };
  }
}
